import React from "react";
import { Col, Container, Row, Tabs, Tab, Accordion } from "react-bootstrap";
import { Link } from "gatsby";

function Appbuild(props) {
  return (
    <div className="services_buildapp p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Case Studies">
              <h2>
                Our Serverless Computing Solution for All Your Business
                Operations
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              TekRevol's serverless computing is designed to deliver businesses
              with the exact units of resources according to the application's
              or organization's demand. As a leading serverless computing
              services provider, our approach aims to make your internal
              developers, teams, and entire organization's focus
              distraction-free by minimizing the time and resources required to
              manage infrastructure.
            </p>
          </Col>
        </Row>
        <Row className="services_bg ">
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="services_tabs deskstop_version"
          >
            <Tabs defaultActiveKey="0" transition={false}>
              <Tab eventKey="0" title="Gaming">
                <div className="content_tabs">
                  <h2>Ether Legend</h2>
                  <p>
                    A superhit blockchain-based NFT card trading game that is
                    backed by Ethereum, Enjin, and polygon networks created by
                    our experts. The game allows users to collect NFTs as
                    rewards and store them as digital assets due to the game’s
                    “play-to-earn” feature. Our game developers create games for
                    many operating systems, giving players an incredible gaming
                    experience.
                  </p>
                  <Link to="/case-studies/ether-legends">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="1" title="Productivity">
                <div className="content_tabs">
                  <h2>AMJ Wellness</h2>
                  <p>
                    AMJ Wellness is a healthcare app developed by TekRevol that
                    ensures employees' emotional and physical well-being and
                    correlates it with productivity. This digital solution
                    promotes a positive relationship between employee well-being
                    and productivity. Later, all of this is related to overall
                    organizational performance.
                  </p>
                  <Link to="/case-studies/amj-wellness">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="2" title="Marketplace">
                <div className="content_tabs">
                  <h2>High Def Events</h2>
                  <p>
                    The High Def Events app developed by our experts is a unique
                    digital auctioneering platform that allows users to interact
                    with it, create films and photographs of their items, offer
                    them for sale on relevant screens, and attract clients to
                    buy them through the app.
                  </p>
                  <Link to="/case-studies/hde">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="3" title="Socializing">
                <div className="content_tabs">
                  <h2>TeeMates</h2>
                  <p>
                    Teemates is a socializing platform designed specifically for
                    golfers and developed by TekRevol experts. The app includes
                    all of the necessary and sophisticated features for the golf
                    community. After registering, users can collaborate, share
                    their stories, and connect with golfers all over the world.
                  </p>
                  <Link to="/case-studies/teemates">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="4" title="Entertainment">
                <div className="content_tabs">
                  <h2>FSK</h2>
                  <p>
                    FSK redefines mobile gaming by seamlessly blending match-3
                    puzzles, time managementchallenges, and role-playing
                    elements. Players embark on a culinary adventure,building a
                    restaurant empire, and applying real-time market strategies
                    to crafttheir success.
                  </p>
                  <Link to="/case-studies/fsk">See case study</Link>
                </div>
              </Tab>
              <Tab eventKey="5" title="Lifestyle">
                <div className="content_tabs">
                  <h2>Stop Vaping</h2>
                  <p>
                    A vast global market uses digital lifestyle products such as
                    desktop programs, wristwatch widgets, and web applications.
                    With a range of monetization choices, these digital
                    solutions provide users with products, information, and
                    helpful content while also opening up significant cash
                    opportunities. TekRevol can create the optimal lifestyle
                    alternative for you.
                  </p>
                  <Link to="/case-studies/stop-vaping">See case study</Link>
                </div>
              </Tab>
            </Tabs>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="services_tabs mobile_version"
          >
            <div className="tekrevol_mobile_accordion">
              <Accordion defaultActiveKey="01">
                <Accordion.Item eventKey="01">
                  <Accordion.Header>Ether Legend</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A superhit blockchain-based NFT card trading game that is
                      backed by Ethereum, Enjin, and polygon networks created by
                      our experts. The game allows users to collect NFTs as
                      rewards and store them as digital assets due to the game’s
                      “play-to-earn” feature. Our game developers create games
                      for many operating systems, giving players an incredible
                      gaming experience.
                    </p>
                    <Link to="/case-studies/ether-legends">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="02">
                  <Accordion.Header>AMJ Wellness</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      AMJ Wellness is a healthcare app developed by TekRevol
                      that ensures employees' emotional and physical well-being
                      and correlates it with productivity. This digital solution
                      promotes a positive relationship between employee
                      well-being and productivity. Later, all of this is related
                      to overall organizational performance.
                    </p>
                    <Link to="/case-studies/amj-wellness">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="03">
                  <Accordion.Header>High Def Events</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The High Def Events app developed by our experts is a
                      unique digital auctioneering platform that allows users to
                      interact with it, create films and photographs of their
                      items, offer them for sale on relevant screens, and
                      attract clients to buy them through the app.
                    </p>
                    <Link to="/case-studies/hde">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="04">
                  <Accordion.Header>TeeMates</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Teemates is a socializing platform designed specifically
                      for golfers and developed by TekRevol experts. The app
                      includes all of the necessary and sophisticated features
                      for the golf community. After registering, users can
                      collaborate, share their stories, and connect with golfers
                      all over the world.
                    </p>
                    <Link to="/case-studies/teemates">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="05">
                  <Accordion.Header>FSK</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      FSK redefines mobile gaming by seamlessly blending match-3
                      puzzles, time managementchallenges, and role-playing
                      elements. Players embark on a culinary adventure,building
                      a restaurant empire, and applying real-time market
                      strategies to crafttheir success.
                    </p>
                    <Link to="/case-studies/fsk">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="06">
                  <Accordion.Header>Stop Vaping</Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A vast global market uses digital lifestyle products such
                      as desktop programs, wristwatch widgets, and web
                      applications. With a range of monetization choices, these
                      digital solutions provide users with products,
                      information, and helpful content while also opening up
                      significant cash opportunities. TekRevol can create the
                      optimal lifestyle alternative for you.
                    </p>
                    <Link to="/case-studies/stop-vaping">See case study</Link>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={4}
            xl={4}
            xxl={4}
            className="services_grade_tabs"
          >
            <Tabs defaultActiveKey="0">
              <Tab eventKey="0" title="Silver">
                <div className="tab_hour">
                  <h4>
                    1172 Hours<span>Average Development Time</span>
                  </h4>
                  <h4>
                    07 Months<span>Average Project Length</span>
                  </h4>
                </div>
              </Tab>
              <Tab eventKey="1" title="Gold">
                <div className="tab_hour">
                  <h4>
                    1619 Hours<span>Average Development Time</span>
                  </h4>
                  <h4>
                    09 Months<span>Average Project Length</span>
                  </h4>
                </div>
              </Tab>
              <Tab eventKey="2" title="Platinum">
                <div className="tab_hour">
                  <h4>
                    3116 Hours<span>Average Development Time</span>
                  </h4>
                  <h4>
                    18 Months<span>Average Project Length</span>
                  </h4>
                </div>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Appbuild;
